<template>
  <main class="p-enteraccount">
    <section class="p-confirmation__wrap">
      <h2 class="c-regist__title">{{ t('ConfirmationPage.title') }}</h2>
      <RegisterFlow :steps="6" :nowStep="5" v-if="!enterAccountStore.isInvitedUser" />
      <p class="c-regist__comment">{{ t('ConfirmationPage.message') }}</p>
      <dl class="p-confirmation__lists">
        <div class="p-confirmation__list" v-if="!enterAccountStore.isExistingAccount">
          <dt class="p-confirmation__list-title">
            <span class="-text">{{ t('ConfirmationPage.displayName') }}</span>
          </dt>
          <dd class="p-confirmation__list-data">{{ enterAccountStore.displayName }}</dd>
        </div>
        <div class="p-confirmation__list" v-if="!enterAccountStore.hasAffiliatedOrganizations">
          <dt class="p-confirmation__list-title">
            <span class="-text">{{ t('ConfirmationPage.id') }}</span>
          </dt>
          <dd class="p-confirmation__list-data">{{ enterAccountStore.username }}</dd>
        </div>
      </dl>
      <div class="p-confirmation__link-wrap">
        <div class="p-confirmation__link">
          <button
            @click="onClickBack"
            class="c-button"
            :class="{ isDisabled: isSendingEnterAccount }"
            :disabled="isSendingEnterAccount"
          >
            <span class="c-button__text">{{ t('ConfirmationPage.back') }}</span>
          </button>
        </div>
        <div class="p-confirmation__link">
          <button
            @click="enterAccount"
            class="c-button"
            :class="{ isDisabled: isSendingEnterAccount }"
            :disabled="isSendingEnterAccount"
          >
            <span class="c-button__text">{{ t('ConfirmationPage.confirm') }}</span>
          </button>
        </div>
      </div>
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import RegisterFlow from '@/components/registerTeam/RegisterFlow.vue'
import StoreUtil from '@/stores/StoreUtil'
import useValidateForAccess from '@/Hooks/useValidateForAccess'
import useEnterAccount from './hook/useEnterAccount'

export default defineComponent({
  name: 'EnterAccountPage',
  setup() {
    const router = useRouter()
    const { t } = useI18n()
    const enterAccountStore = StoreUtil.useStore('EnterAccountStore')
    const { enterAccount, isSendingEnterAccount } = useEnterAccount()

    onMounted(() => {
      let propertyNames = [
        'tokenId',
        'displayName',
        'username',
        'password',
      ] as (keyof typeof enterAccountStore)[]
      if (enterAccountStore.hasAffiliatedOrganizations) {
        // 既に他組織に所属済みユーザの新規組織作成のとき
        propertyNames = ['tokenId', 'displayName']
      } else if (enterAccountStore.isExistingAccount) {
        // 既に他組織に所属済みユーザが他チームに招待されたとき
        propertyNames = ['tokenId', 'accessToken']
      }
      useValidateForAccess('EnterAccountStore', propertyNames, 'ErrorPage')
    })
    return {
      enterAccountStore,
      t,
      isSendingEnterAccount,
      enterAccount,
      onClickBack() {
        enterAccountStore.password = ''
        let name = 'RegistPage'
        if (enterAccountStore.isExistingAccount) {
          name = 'AddTeamPage'
        } else if (enterAccountStore.isInvitedUser) {
          name = 'InvitePage'
        }
        router.replace({
          name,
          query: { tokenId: enterAccountStore.tokenId },
        })
      },
    }
  },
  components: {
    RegisterFlow,
  },
})
</script>

<style scoped lang="scss">
.isDisabled {
  opacity: 0.3;
  pointer-events: none;
}
</style>
